import moment from 'moment'
import { useMemo } from 'react'

import { IColumnsType } from 'pared/components/basicUi/table'

import { IScopeOption } from '../gql'
import formatRuleSummary from '../ruleSummary'
import { ISettingRule } from './usePrepSettings'

export interface IPrepSettingsScheduleTableData {
  key: number
  startDate: string
  endDate: string
  rules: ISettingRule[]
}

const usePrepSettingsScheduleColumns = (
  scopeById: Record<number, IScopeOption>,
): IColumnsType<IPrepSettingsScheduleTableData>[] => {
  return useMemo(
    () =>
      [
        {
          key: 'startDate',
          title: 'Start',
          minWidth: '150px',
          align: 'left',
          render: (_: any, record: IPrepSettingsScheduleTableData) =>
            moment(record.startDate).format('M/D/YYYY'),
        },
        {
          key: 'endDate',
          title: 'End',
          minWidth: '150px',
          align: 'left',
          render: (_: any, record: IPrepSettingsScheduleTableData) =>
            moment(record.endDate).format('M/D/YYYY'),
        },
        {
          key: 'rules',
          title: 'Applies to',
          minWidth: '280px',
          align: 'left',
          render: (_: any, record: IPrepSettingsScheduleTableData) =>
            record.rules.length === 0
              ? '—'
              : formatRuleSummary(record.rules, scopeById),
        },
      ] as IColumnsType<IPrepSettingsScheduleTableData>[],
    [scopeById],
  )
}

export default usePrepSettingsScheduleColumns
